import {
  ActionIcon,
  Button,
  Divider,
  Modal,
  SegmentedControl,
  Select,
  Skeleton,
  Table,
  Text,
  Textarea,
  TextInput,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import React, { useEffect, useState } from "react";
import AWS from "aws-sdk/global";
import S3 from "aws-sdk/clients/s3";
import { getDeptUsers, getStandardObligations } from "../apis/userApis";
import {
  converDateToISO,
  convertToISO8601,
  getActFrequencyText,
  getDepartmentText,
  getRecFrequencyText,
} from "./utilities";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData } from "../redux/authSlice";
import {
  createObligationApi,
  getObligationsForAgreement,
} from "../apis/obligationApi";
import { getFile, getReadUrl } from "../apis/fileApi";
import { departmentData } from "./utilities";
import { getCookiesSession } from "../apis/cookiesSession";
import DocsLocker from "./DocsLocker";
import { IconPlus } from "@tabler/icons-react";
import MasterObForAgreement from "../componenets/masterObForAgreement";
import { showNotification } from "@mantine/notifications";

const LegacyAgreementForm2 = ({ setUiConfigs, details }) => {
  const [standardObligations, setStandardObligations] = useState(null);
  const [options, setOptions] = useState(["select"]);
  const [createobligation, setCreateObligation] = useState(false);
  const [file, setFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [agreementId, setAgreementId] = useState(0);
  const [obligations, setObligations] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [connectObModal, setConnectObModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [rowId, setRowId] = useState(null);
  
  console.log(details);
  const dispatch = useDispatch();
  const userData = JSON.parse(getCookiesSession("userData"));
  //   const currentUrl = window.location.href;
  // console.log(currentUrl);
  console.log("details: ", details);
  const [url, setUrl] = useState(null);
  const [mimeType, setMimeType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [assignToData, setAssignToData] = useState([]);
  const [draft, setDraft] = useState(false);
  useEffect(() => {
    const attachedFile = async () => {
      const response = await getFile({ id: details.agreementId });
      console.log("response: ", response);
      setFile(response.file);
    };
    attachedFile();
  }, [details.agreementId]);
  const fetchObligationsforAgreement = async () => {
    const response = await getObligationsForAgreement({
      agreementId: agreementId,
    });
    console.log(response);
    setObligations(response.obligations);
  };
  useEffect(() => {
    if (agreementId > 0) fetchObligationsforAgreement();
  }, [agreementId]);
  useEffect(() => {
    const getObligationsOptions = async () => {
      const response = await getStandardObligations();
      setStandardObligations(response.obligationData);
      if (response.obligationData.length > 0) {
        setOptions(response.outputArray);
      }
    };
    getObligationsOptions();
    const getassignToUsers = async () => {
      const response = await getDeptUsers();
      setAssignToData(response.userData);
    };
    getassignToUsers();
  }, []);

  const [obligationData, setObligationData] = useState({
    clNo: "",
    title: "",
    desc: "",
    actFrequency: 1,
    recFrequency: 7,
    startDate: "",
    endDate: details.endDate,
    department: userData.activeDepartment,
    reminderTime: 1,
    remarks: "",
    businessUnit: details.businessUnit,
    mapRegion: details.mapRegion,
    local: details.local,
    connectedAgreement: details.agreementId,
    connectedParty: details.secondParty,
    extraCol1: details.typeOfAgreement,
    createdBy: userData.name,
    createdId: userData.id,
    createdByEmail: userData.email,
    assignTo: null,
    jobOrder: details.jobOrder,
    brandName: details.brandName,
    draft: false,
    dependedOb: null,
    stage: null,
  });

  console.log(details);
  const drive = "https://drive.google.com/";

  function validate(obligationObj) {
    const keys = {};
    console.log("in obligation obj: ", obligationObj);
    if (!obligationObj.clNo || obligationObj.clNo.trim().length === 0) {
      keys.clNo = "Please enter clause number";
    }
    if (!obligationObj.title || obligationObj.title.trim().length === 0) {
      keys.title = "Please enter title";
    }
    if (!obligationObj.desc || obligationObj.desc.trim().length === 0) {
      keys.desc = "please add description";
    }
    if (
      !draft &&
      (!obligationObj.startDate ||
        obligationObj.startDate > obligationObj.endDate)
    ) {
      keys.startDate = "please enter valid start date";
      showNotification({
        title: "start date",
        message: "enter valid start date",
        color: "red",
      });
    }
    if (
      !obligationObj.endDate ||
      obligationObj.endDate < obligationObj.startDate
    ) {
      keys.endDate = "please enter valid end date";
    }
    if (!obligationObj.assignTo) {
      keys.assignTo = "please fill assigned too";
    }
    if (parseInt(obligationData.businessUnit) === 1 && !obligationData.stage) {
      keys.stage = "please select stage";
    }
    if (Object.keys(keys).length > 0) {
      setConnectObModal(false);
      setLoadingButton(false);
      setObligationData({ ...obligationData, dependedOb: null });
      setDraft(false);
      setErrors(keys);
      return false;
    } else {
      return true;
    }
  }
  useEffect(() => {
    if (file) {
      const getPreviewUrl = async () => {
        const intialurl = file.hostedLink;
        if (intialurl.slice(0, 10) === drive.slice(0, 10)) {
          setUrl(intialurl);
          setLoading(false);
        } else {
          console.log("intialUrl = ", intialurl);
          setMimeType(file.mimeType);
          const key = file.extraCol1;
          const response = await getReadUrl({ hostedLink: file.hostedLink });
          if (response.success) {
            setUrl(response.signedUrl);
            setLoading(false);
          }
        }
      };
      getPreviewUrl();
    }
  }, [file]);
  console.log("file: ", file);
  const handleCreate = (newItem) => {
    setOptions([...options, newItem]);
    setObligationData({ ...obligationData, title: newItem });
  };
  const createNewObligation = async (e) => {
    if (validate(obligationData)) {
      // e.preventDefault();
      const data = { ...obligationData, draft: draft };
      const response = await createObligationApi({ body: data });
      if (response.success) {
        console.log("obligation created");
        setCreateObligation(false);
        setLoadingButton(false);
        setConnectObModal(false);
        setObligationData({
          clNo: "",
          title: "",
          desc: "",
          actFrequency: 1,
          recFrequency: 7,
          startDate: "",
          endDate: details.endDate,
          department: userData.activeDepartment,
          reminderTime: 1,
          remarks: "",
          businessUnit: details.businessUnit,
          mapRegion: details.mapRegion,
          local: details.local,
          connectedAgreement: details.agreementId,
          connectedParty: details.secondParty,
          extraCol1: details.typeOfAgreement,
          createdBy: userData.name,
          createdId: userData.id,
          createdByEmail: userData.email,
          assignTo: null,
          jobOrder: details.jobOrder,
          brandName: details.brandName,
          draft: false,
          dependedOb: null,
        });
        if (rowId) {
          const updated = obligations.filter((item) => item.id !== rowId);
          setObligations(updated);
        }
      }
    }
  };
  const onAddObligation = async (obligation) => {
    console.log("obligation: ", obligation);

    const preparedData = {
      clNo: obligation.clNo,
      title: obligation.title,
      desc: obligation.desc,
      actFrequency: obligation.actFrequency,
      recFrequency: obligation.recFrequency,
      startDate: obligation.startDate,
      endDate:
        obligation.actFrequency === 1 ? obligation.endDate : details.endDate,
      department: obligation.department,
      reminderTime: obligation.reminderTime,
      remarks: "",
      businessUnit: details.businessUnit,
      mapRegion: details.mapRegion,
      local: details.local,
      connectedAgreement: details.agreementId,
      connectedParty: details.secondParty,
      extraCol1: details.typeOfAgreement,
      createdBy: userData.name,
      createdId: userData.id,
      createdByEmail: userData.email,
      assignTo: obligation.assignTo.id,
      jobOrder: details.jobOrder,
      brandName: details.brandName,
      draft: draft,
      dependedOb: null,
      stage: obligation.stage,
    };
    if (validate(preparedData)) {
      const response = await createObligationApi({ body: preparedData });
      if (response.success) {
        const updated = obligations.filter((item) => item.id !== obligation.id);
        setObligations(updated);
        setDisabled(false);
      }
    }
  };
  const [expandedId, setExpandedId] = useState(null);
  const handleExpand = (id) => {
    setExpandedId(id); // Set the ID of the obligation to expand
  };

  const onSelectOb = async (id) => {
    setObligationData({
      ...obligationData,
      dependedOb: id,
    });
  };
  console.log(obligationData);
  console.log("errors", errors);
  return (
    <>
      <div>
        {file && url && mimeType && !loading && (
          <iframe
            src={url}
            type="application/pdf"
            width="100%"
            height="400px"
            title="Agreement View"
          />
        )}
        {loading && <Skeleton width={"100%"} height={"400px"} />}
        <div className="flex justify-between">
          <Button onClick={() => setCreateObligation(true)} className="mt-2">
            Add Obligation
          </Button>
          <Button onClick={() => setShowModal(true)} className="mt-2">
            Import Obligations
          </Button>
        </div>
        {createobligation && (
          <>
            <div className=" w-full flex flex-row gap-1 mt-2">
              <TextInput
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                placeholder="clause no."
                label="clause no."
                className="text-center rounded-sm  w-1/12"
                value={obligationData.clNo}
                onChange={(e) =>
                  setObligationData({ ...obligationData, clNo: e.target.value })
                }
                error={errors.clNo && errors.clNo}
              />
              <Select
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                placeholder="title"
                label="title"
                className="text-center rounded-sm w-2/12"
                value={obligationData.title}
                data={options}
                searchable
                creatable
                getCreateLabel={(query) => `+ Add "${query}"`}
                onCreate={handleCreate}
                onChange={
                  (val) => {
                    const selectedObligation = standardObligations.find(
                      (obligation) => obligation.title === val,
                    );
                    if (selectedObligation) {
                      setObligationData({
                        ...obligationData,
                        title: val,
                        desc: selectedObligation.desc,
                        actFrequency: selectedObligation.actFrequency,
                        recFrequency: selectedObligation.recFrequency,
                        department: selectedObligation.department,
                        reminderTime: selectedObligation.reminderTime,
                      });
                    }
                  }
                  // setObligationData({
                  //   ...obligationData,
                  //   title: val,
                  // })
                }
                error={errors.title && errors.title}
              />
              <TextInput
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                value={obligationData.desc}
                placeholder="description"
                label="description"
                className="text-center rounded-sm w-2/12"
                onChange={(e) =>
                  setObligationData({ ...obligationData, desc: e.target.value })
                }
                error={errors.desc && errors.desc}
              />
              <Select
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                label="act. frequency"
                className="text-center w-1/12"
                placeholder="select act. frequency"
                value={obligationData.actFrequency?.toString()}
                data={[
                  { label: "one-time", value: "1" },
                  { label: "on-going", value: "2" },
                  { label: "recurring", value: "3" },
                ]}
                onChange={(val) =>
                  setObligationData({
                    ...obligationData,
                    actFrequency: Number(val),
                  })
                }
              />
              {obligationData.actFrequency !== 1 && (
                <Select
                  required
                  labelProps={{
                    sx: {
                      fontSize: ".75rem",
                    },
                  }}
                  value={obligationData.recFrequency?.toString()}
                  label="rec. frequency"
                  className="text-center w-1/12"
                  placeholder="select rec. frequency"
                  data={[
                    { label: "weekly", value: "7" },
                    { label: "fortnight", value: "14" },
                    { label: "monthly", value: "30" },
                    { label: "quarterly", value: "90" },
                    { label: "half-yearly", value: "182" },
                    { label: "annually", value: "365" },
                  ]}
                  onChange={(val) =>
                    setObligationData({ ...obligationData, recFrequency: val })
                  }
                />
              )}
              <DatePicker
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                value={obligationData.startDate}
                //minDate={new Date()}
                label="start date"
                className="text-center w-1/12"
                placeholder="start date"
                onChange={(val) =>
                  setObligationData({
                    ...obligationData,
                    startDate: convertToISO8601(converDateToISO(val)),
                  })
                }
                error={errors.startDate && errors.startDate}
              />
              {obligationData.actFrequency === 1 && (
                <DatePicker
                  //minDate={new Date()}
                  required
                  labelProps={{
                    sx: {
                      fontSize: ".75rem",
                    },
                  }}
                  label="end date"
                  className="text-center w-1/12"
                  placeholder="end date"
                  value={obligationData.endDate}
                  onChange={(val) =>
                    setObligationData({
                      ...obligationData,
                      endDate: convertToISO8601(converDateToISO(val)),
                    })
                  }
                  error={errors.endDate && errors.endDate}
                />
              )}
              <Select
                className="w-1/12"
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                placeholder="department"
                label="department"
                required
                data={departmentData}
                value={obligationData.department?.toString()}
                onChange={(val) =>
                  setObligationData({ ...obligationData, department: val })
                }
              />
              <Select
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                label="assign to"
                className="text-center w-1/12"
                placeholder="assign to"
                value={obligationData.assignTo}
                data={assignToData}
                onChange={(val) =>
                  setObligationData({ ...obligationData, assignTo: val })
                }
                error={errors.assignTo && errors.assignTo}
              />
              <Select
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                label="reminder time"
                className="text-center w-1/12"
                placeholder="reminder time"
                value={obligationData.reminderTime?.toString()}
                data={[
                  { label: "1-day", value: "1" },
                  { label: "2-days", value: "2" },
                  { label: "3-days", value: "3" },
                  { label: "4-days", value: "4" },
                  { label: "5-days", value: "5" },
                  { label: "6-days", value: "6" },
                  { label: "7-days", value: "7" },
                  { label: "10-days", value: "10" },
                  { label: "15-days", value: "15" },
                  { label: "30-days", value: "30" },
                  { label: "45-days", value: "45" },
                  { label: "60-days", value: "60" },
                  { label: "90-days", value: "90" },
                ]}
                onChange={(val) =>
                  setObligationData({ ...obligationData, reminderTime: val })
                }
              />
              <Select
                required={parseInt(obligationData.businessUnit) === 1}
                className="text-center w-1/12"
                label="stage"
                placeholder="select stage"
                data={["planning", "execution", "closure"]}
                onChange={(val) => {
                  setObligationData({ ...obligationData, stage: val });
                }}
                value={obligationData.stage}
                error={errors.stage && errors.stage}
              />
            </div>
            <div className="flex justify-between mt-1">
              <div></div>
              <div className="gap-4">
                <Button
                  loading={loadingButton}
                  onClick={(e) => {
                    if (validate(obligationData)) {
                      setDraft(true);
                      setLoadingButton(true);
                      // createNewObligation(e);
                      setConnectObModal(true);
                    }
                  }}
                  // color="yellow"
                  variant="outline"
                  className="mr-2"
                >
                  Connect
                </Button>
                <Button
                  onClick={(e) => {
                    setLoadingButton(true);
                    createNewObligation(e);
                  }}
                  loading={loadingButton}
                >
                  Save
                </Button>
              </div>
            </div>
          </>
        )}
        <div className="mt-2">
          {obligations && obligations.length > 0 && agreementId && (
            <div className="bg-gray-200">
              <div className="text-center flex">
                {/* <th className="text-center w-1/12">select</th> */}
                <th className="text-center w-1/12">clause no.</th>
                <th className="text-center w-1/12">obligation title</th>
                <th className="text-center w-2/12">description</th>
                <th className="text-center w-1/12">act. frequency</th>
                <th className="text-center w-1/12">rec. frequency/end date</th>
                <th className="text-center w-1/12">start date</th>
                <th className="text-center w-1/12">reminder time</th>
                <th className="text-center w-1/12">department</th>
                <th className="text-center w-1/12">assigned to</th>
                <th className="text-center w-1/12">stage</th>
                <th>&nbsp;</th>
              </div>
              {obligations &&
                obligations.map((row, index) => (
                  <div className="text-center flex mt-1" key={row.id}>
                    <div className="text-center w-1/12">{row.clNo}</div>
                    <div className="text-center w-1/12">{row.title}</div>
                    <div className="text-center w-2/12">
                      {expandedId === row.id ? row.desc : row.desc.slice(0, 50)}
                      {expandedId !== row.id && row.desc.length > 50 && (
                        <span
                          onClick={() => handleExpand(row.id)}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          ...
                        </span>
                      )}
                    </div>
                    <div className="text-center w-1/12">
                      {getActFrequencyText(row.actFrequency)}
                    </div>
                    <div className="text-center w-1/12">
                      {row.actFrequency !== 1 ? (
                        getRecFrequencyText(row.recFrequency)
                      ) : (
                        <>
                          <input
                            type="date"
                            style={{ width: "100%" }}
                            className="bg-white rounded border border-gray-300 px-2 py-1"
                            value={row.endDate ? row.endDate.slice(0, 10) : ""}
                            onChange={(e) => {
                              const updated = [...obligations];
                              updated[index].endDate = new Date(
                                e.target.value,
                              ).toISOString(); // convert back to ISO format
                              setObligations(updated);
                            }}
                          />
                          {errors.endDate && rowId === row.id && (
                            <p className="text-xs text-red-500">
                              {errors.endDate}
                            </p>
                          )}
                        </>
                      )}
                    </div>
                    <div className="text-center w-1/12">
                      <input
                        style={{ width: "100%" }}
                        type="date"
                        className="bg-white rounded border border-gray-300 px-2 py-1 "
                        value={row.startDate ? row.startDate.slice(0, 10) : ""}
                        onChange={(e) => {
                          const updated = [...obligations];
                          updated[index].startDate = new Date(
                            e.target.value,
                          ).toISOString(); // convert back to ISO format
                          setObligations(updated);
                        }}
                      />
                      {errors.startDate && rowId === row.id && (
                        <p className="text-xs text-red-500">
                          {errors.startDate}
                        </p>
                      )}
                    </div>
                    <div className="text-center w-1/12">
                      {row.reminderTime}-days
                    </div>
                    <div className="text-center w-1/12">
                      {getDepartmentText(row.department)}
                    </div>
                    <div className="text-center w-1/12">
                      {row.assignTo.name}
                    </div>
                    <div className="text-center w-1/12">
                      <Select
                        className=""
                        placeholder="select stage"
                        data={["planning", "execution", "closure"]}
                        onChange={(val) => {
                          const updated = [...obligations];
                          updated[index].stage = val; // convert back to ISO format
                          setObligations(updated);
                        }}
                      />
                    </div>
                    <div className="text-center w-1/12">
                      <div className="flex flex-col">
                        <Button
                          disabled={disabled}
                          onClick={() => {
                            setLoadingButton(true);
                            setRowId(row.id);
                            onAddObligation(row);
                          }}
                          // color="white"
                        >
                          Save
                        </Button>
                        <Button
                          loading={disabled}
                          onClick={(e) => {
                            setDraft(true);
                            setRowId(row.id);
                            setLoadingButton(true);
                            const preparedData = {
                              clNo: row.clNo,
                              title: row.title,
                              desc: row.desc,
                              actFrequency: row.actFrequency,
                              recFrequency: row.recFrequency,
                              startDate: row.startDate,
                              endDate:
                                row.actFrequency === 1
                                  ? row.endDate
                                  : details.endDate,
                              department: row.department,
                              reminderTime: row.reminderTime,
                              remarks: "",
                              businessUnit: details.businessUnit,
                              mapRegion: details.mapRegion,
                              local: details.local,
                              connectedAgreement: details.agreementId,
                              connectedParty: details.secondParty,
                              extraCol1: details.typeOfAgreement,
                              createdBy: userData.name,
                              createdId: userData.id,
                              createdByEmail: userData.email,
                              assignTo: row.assignTo.id,
                              jobOrder: details.jobOrder,
                              brandName: details.brandName,
                              draft: draft,
                              stage: row.stage,
                              dependedOb: null,
                            };
                            setObligationData(preparedData);
                            // createNewObligation(e);
                            setConnectObModal(true);
                          }}
                          variant="outline"
                          className="mt-1"
                        >
                          Connect
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
        <div className="flex flex-row justify-between">
          {/* <Button
            style={{
              backgroundColor: "#1b6f8d",
            }}
            onClick={() => setUiConfigs({ currentStep: 0 })}
            className="mt-3"
          >
            previous
          </Button> */}
          <div></div>
          <Button
            style={{
              backgroundColor: "#1b6f8d",
            }}
            onClick={() => setUiConfigs({ currentStep: 2 })}
            className="mt-3"
          >
            View Obligations
          </Button>
        </div>
      </div>
      <Modal
        opened={showModal}
        onClose={() => setShowModal(false)}
        size="calc(80vw)"
      >
        <DocsLocker
          showSelect={true}
          setAgreementId={setAgreementId}
          setShowModal={setShowModal}
        />
      </Modal>
      <Modal
        opened={connectObModal}
        onClose={() => {
          setConnectObModal(false);
          setLoadingButton(false);
          setObligationData({ ...obligationData, dependedOb: null });
          setDraft(false);
        }}
        title="Select Connected Obligation"
        size="calc(80vw)"
      >
        <MasterObForAgreement
          dependedOb={obligationData.dependedOb}
          onSelectOb={onSelectOb}
          agreementId={details.agreementId}
          local={details.local}
          createNewObligation={createNewObligation}
        />
      </Modal>
    </>
  );
};

export default LegacyAgreementForm2;
